t = require('views/internal/teacup-with-helpers')('description')

module.exports = t.renderable ({ editable, isCardDesc, placeholderKey }) ->
  t.div '.window-module', ->

    t.div '.window-module-title.window-module-title-no-divider.description-title', ->
      t.span '.icon-description.icon-lg.window-module-title-icon'
      t.h3 '.u-inline-block', ->
        t.format 'description'
      if editable
        t.div { class: t.classify(editable: editable), attr: 'desc' }, ->
          t.a '.button.subtle.hide-on-edit.js-show-with-desc.js-edit-desc', { href: '#' }, ->
            t.format 'edit'

    # description body
    t.div '.u-gutter', ->
      t.div { class: t.classify(editable: editable), attr: 'desc' }, ->

        t.div '.description-content.js-desc-content', ->
          t.div '.description-content-fade-button', ->
            t.span '.description-content-fade-button-text', ->
              t.format 'show-full-description'

          t.div '.current.markeddown.hide-on-edit.js-desc.js-show-with-desc.hide', { dir: 'auto' }

          if editable
            t.p '.u-bottom.js-hide-with-desc', ->
              t.a { class: t.classify(
                'description-fake-text-area hide-on-edit js-edit-desc js-hide-with-draft': true,
                'large': !isCardDesc
              ), href: '#' }, ->
                t.format placeholderKey

            t.div '.description-edit.edit', ->
              t.a '.helper.button.subtle.js-format-help', { href: '#' }, ->
                t.format 'formatting-help'

              t.textarea '.field.field-autosave.js-description-draft.description', {
                placeholder: t.l(placeholderKey)
              }

            # Edits warning only shows when autosave is not turned on
            t.p '.edits-warning.quiet', ->
              t.format 'you-have-unsaved-edits-on-this-field'
              t.text ' '
              t.a '.js-view-edits', { href: '#' }, ->
                t.format 'view-edits'
              t.text " - "
              t.a '.js-discard-edits', { href: '#' }, ->
                t.format 'discard'
            t.p '.edits-error.error', ->
              t.format 'edit-not-saved'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/description.coffee